import React from 'react';
import Icon from 'react-icon-base';
import { any, number, oneOfType, string } from 'prop-types';

/* prettier-ignore */
const MedalIcon = ({
  className, color, height, size, style, width, ...restProps
}) => (
  /* eslint-disable */
  <Icon
    className={className}
    color={color}
    height={height}
    size={size}
    style={style}
    viewBox="0 0 16 16"
    width={width}
    {...restProps}
  >
    <g>
      <path fillRule="evenodd" d="M14 5.6c0 3.093-2.686 5.6-6 5.6S2 8.693 2 5.6C2 2.507 4.686 0 8 0s6 2.507 6 5.6ZM7.268 4.018c.326-.545.488-.818.732-.818s.406.273.732.818l.084.141c.093.155.14.233.211.284.072.05.162.07.342.108l.164.034c.632.134.948.2 1.024.426.075.226-.14.461-.571.932l-.112.122c-.123.133-.184.2-.212.283-.027.083-.018.172 0 .35l.017.163c.065.627.098.942-.099 1.082-.197.139-.493.012-1.085-.243l-.153-.066c-.168-.072-.253-.108-.342-.108-.09 0-.173.036-.341.108l-.154.066c-.592.255-.888.382-1.085.242-.197-.14-.164-.453-.1-1.08l.018-.163c.018-.179.027-.268 0-.35-.028-.083-.089-.15-.212-.284l-.111-.122c-.431-.47-.647-.706-.572-.932.076-.225.392-.292 1.024-.426l.164-.034c.18-.038.27-.057.342-.108.072-.051.118-.129.21-.284l.085-.141Z" clipRule="evenodd"/>
  <path d="m3.47 12.258.324-1.106A7.611 7.611 0 0 0 8 12.4a7.612 7.612 0 0 0 4.206-1.247l.325 1.106c.538 1.833.807 2.75.448 3.252a1.277 1.277 0 0 1-.491.41c-.56.266-1.423-.154-3.15-.994-.575-.28-.863-.42-1.168-.45a1.714 1.714 0 0 0-.34 0c-.306.03-.593.17-1.168.45-1.727.84-2.591 1.26-3.15.994a1.278 1.278 0 0 1-.491-.41c-.36-.502-.09-1.419.448-3.252Z"/>
    </g>
  </Icon>
  /* eslint-enable */
);

MedalIcon.propTypes = {
  className: string,
  color: string,
  height: oneOfType([string, number]),
  size: oneOfType([string, number]),
  style: any, // eslint-disable-line react/forbid-prop-types
  width: oneOfType([string, number]),
};

export default MedalIcon;
